export const PRIVACY_POLICY_URL =
  "https://www.ses.nsw.gov.au/myavailabilityprivacy";
